/**
* This file originated from:
* File: app/views/movie/layouts/desktop.html
* In commit: 6fba2b906e6b84c9bd2e3e2766aaf825c82f4f78
* For ticket: GRINS-1511
*/

import '@take-2/assets/javascripts/templates/movie/layouts/desktop.js';
import '@take-2/assets/javascripts/bundles/transpiled/movie/layouts/desktop.movieState-app.js';
